// extracted by mini-css-extract-plugin
export default {"Container":"Loading__Container__amCP6","LoadingIcon":"Loading__LoadingIcon__XaKyp","LoadingText":"Loading__LoadingText__dXRnA"};